import styled from 'styled-components';

import { FiPlus, FiMinus, FiTrash2 } from 'react-icons/fi';
import { layout } from '../../../../package.json';

export const PlusIcon = styled(FiPlus)``;
export const MinusIcon = styled(FiMinus)``;
export const DeleteIcon = styled(FiTrash2)``;

export const DeleteContainer = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  justify-content: flex-end;
  gap: 10px;
`;

export const ProductRow = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;

  width: 100%;
  padding: 0.5rem 2%;
  margin-bottom: 5px;
  border-radius: 10px;
  background-color: #e4e3e3;

  > div + div {
    margin-left: 1rem;
  }
`;

export const ContainerImagem = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  width: 100%;
  min-width: 70px;
  max-width: 70px;
  margin-right: 10px;
`;

export const ProductCategory = styled.div`
  padding: 6px;

  span {
    color: var(--gray-light);
    font-size: 12px;
    font-weight: 400;
  }
`;

export const CotainerActions = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;

  width: 100%;
  padding: 0.5rem;

  text-align: center;
  background: var(--gray-light);
  border: 1px solid var(--gray-light);
  border-radius: 0.9rem;
`;



export const QtyTitle = styled.div`
  span {
    font-size: 0.75rem;
    font-weight: 300;
  }
`;

export const InputQty = styled.input`
  width: 80px;
  color: var(--gray);
  text-align: center;
  font-size: 1.25rem;
  font-weight: 600;
`;

export const Botton = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  cursor: pointer;
`;

export const ContainerRemove = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  flex: 1;
`;

export const ButtonRemove = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  padding: 0 1rem;
  span {
    color: #fff;
    font-size: 1.33rem;
    font-weight: 800;
  }

  svg {
    font-size: 1.56rem;
  }
`;

export const Content = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;

  @media (max-width: ${layout.desktop}) {
    flex-direction: column;
  }
`;

export const QuantityControl = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f4f4f4;
  border-radius: 10px;
  gap: 6px;
  height: 32px;
  padding: 1px 8px;
  height: 32px;
`;

